export const COMPANY_NAME = "Murse Mark Holistic Health Coach LLC";
export const COMPANY_SHORT = "Murse Mark Holistic Health Coach";
export const COMPANY_INITIALS = "MMH";
export const COMPANY_ADDRESS_FULL = "1029 Southwood Dr APT D, San Luis Obispo, California, US 93401-5871";
export const COMPANY_LOCATION = "San Luis Obispo, California";
export const COMPANY_REGION = "San Luis Obispo, California";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=1029%20Southwood%20Dr%20APT%20D%2C%20San%20Luis%20Obispo%2C%20California%2C%20US%2093401-5871";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Focus", "value": "Public profile" },
  { "label": "Service Area", "value": "San Luis Obispo, California" },
  { "label": "Location", "value": "San Luis Obispo, California" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "Murse Mark Holistic Health Coach LLC" },
  { "label": "City / State", "value": "San Luis Obispo, California" },
  { "label": "Address", "value": "1029 Southwood Dr APT D, San Luis Obispo, California, US 93401-5871" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Public profile", "body": "A concise directory profile for publicly available organization information." },
  { "icon": "✦", "title": "Organization", "body": "Murse Mark Holistic Health Coach LLC." },
  { "icon": "✿", "title": "Location", "body": "San Luis Obispo, California." },
  { "icon": "❍", "title": "Visit", "body": "Use the address and map link for location details." },
];
